var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGooglePlayLogo = function SvgIconGooglePlayLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.624 1.471a1.75 1.75 0 0 1 1.745.018l11.57 6.626a1 1 0 0 1 .095.055l4.05 2.319a1.721 1.721 0 0 1 0 3.022l-4.05 2.32a1 1 0 0 1-.095.054L5.37 22.51a1.75 1.75 0 0 1-2.007-.163 1 1 0 0 1-.192-.186 1.75 1.75 0 0 1-.438-1.144V2.982a1.75 1.75 0 0 1 .438-1.144 1 1 0 0 1 .192-.186 2 2 0 0 1 .262-.18m1.107 3.174v14.71L12.086 12zm8.77 5.94L8.502 5.589l6.355 3.64zm0 2.83-4.998 4.997 6.355-3.64zm3.155.327L14.914 12l1.742-1.742L19.698 12z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGooglePlayLogo;